
import {Component, Prop} from "vue-property-decorator";
import {HcPageModel} from "@dev/hc-components";
import QrCodeWithLogo from 'qrcode-with-logos';

@Component
export default class QrCode extends HcPageModel
{
    @Prop({type: String}) public link!: string;
    public name: string = "qrCode";
    protected pageName: string = "qrCode";

    public mounted(): void
    {
        const canvas = document.getElementById("qrCodeCanvas") as HTMLCanvasElement;
        const qrcode = new QrCodeWithLogo({
            canvas: canvas,
            content: this.link,
            width: 250,
        });
    }
}
